import settings from '@/settings'

const mudarStatusFisio = (headers, id) => {
    return fetch(`${settings.fisioApi}/admin/status-fisioterapeuta/?id_fisio=${id}`, {
        method: 'PUT',
        mode: 'cors',
        cache: 'default',
        headers: headers,
    })
}

export default {
    mudarStatusFisio,
}